module.exports = __webpack_public_path__ + "static/media/A8.736497cd.jpg";